import { render } from "./StepThrough.vue?vue&type=template&id=47b2bd23&scoped=true"
import script from "./StepThrough.vue?vue&type=script&lang=js"
export * from "./StepThrough.vue?vue&type=script&lang=js"

import "./StepThrough.vue?vue&type=style&index=0&id=47b2bd23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b2bd23"]])

export default __exports__